import { ApiClient } from '../ApiClient.js';

export class GoalsApiService {
    static async list({ page = 1, per_page = 50 } = {}) {
        return ApiClient.get('/api/v1/goals', { page, per_page });
    }
    static async create(payload) {
        return ApiClient.post('/api/v1/goals', payload);
    }
    static async get(id) {
        return ApiClient.get(`/api/v1/goals/${id}`);
    }
    static async update(id, payload) {
        return ApiClient.put(`/api/v1/goals/${id}`, payload);
    }
    static async remove(id) {
        return ApiClient.delete(`/api/v1/goals/${id}`);
    }
    static async progress(id) {
        return ApiClient.get(`/api/v1/goals/${id}/progress`);
    }
}
